import React from "react";
import "./HowItWorks.css";

const timelineSteps = [
  {
    step: 1,
    title: "Initial Consultation",
    description: "We discuss your goals and tailor a strategy to enter the Indian market.",
  },
  {
    step: 2,
    title: "Sourcing & Setup",
    description: "We connect you with reliable partners, suppliers, and infrastructure.",
  },
  {
    step: 3,
    title: "Launch & Logistics",
    description: "We handle import, warehousing, and distribution to ensure smooth delivery.",
  },
  {
    step: 4,
    title: "Growth & Scale",
    description: "We help scale your presence with data, optimization, and long-term support.",
  },
];

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <div className="container-howitwork">
        <h2 className="timeline-heading">Your Global Launch Timeline</h2>

        <div className="stepper-container">
          {timelineSteps.map((item, index) => (
            <React.Fragment key={item.step}>
              <div className="step-card">
                <div className="step-number">{item.step}</div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>

              {index !== timelineSteps.length - 1 && (
                <div className="step-line" />
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="timeline-btn-wrap">
          <button className="timeline-cta">Start with Free Trial</button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
